<template>
  <div
    :class="{
      BoxContent: true,
      BoxMore: detail.share_list.length > 1,
    }"
    ref="scrollContainer"
  >
    <div class="boxOne">
      <img :src="detail.logo" class="leftLogo" />
      <div class="rightBox">
        <div class="topBox">
          <div class="leftU">
            <span class="font1"
              >{{ detail.username }}&nbsp;{{ $t('model.SharedLink') }}</span
            >
            <span class="font2"
              >{{ $t('model.mtext1') }}{{ detail.username
              }}{{ $t('model.mtest2') }}</span
            >
            <span class="font3" @click="checkReport">{{
              $t('model.report')
            }}</span>
          </div>
          <svg-btn
            @click="checkCollect"
            :icon-class="
              detail.is_collect == 1 ? 'icon-collect-two' : 'icon-collect-one'
            "
            class="collect"
          ></svg-btn>
        </div>
      </div>
    </div>
    <!-- <div class="boxTwo">
      <el-carousel :interval="3000" trigger="click" arrow="never">
        <el-carousel-item
          v-for="(item, index) in $store.state.banner"
          :key="index"
        >
          <img :src="item.img" class="img" @click="open(item.url)" />
        </el-carousel-item>
      </el-carousel>
    </div> -->
    <template v-if="detail.share_list.length == 1">
      <div
        class="boxThree"
        v-for="(item, index) in detail.share_list"
        :key="index"
      >
        <div class="topBox">
          <div class="imgBox">
            <img :src="item.icon" class="topImg" />
          </div>
          <span class="font4">{{ item.url_title }}</span>
        </div>
        <div
          class="cBoxNo"
          @click="checkRebate($event, item)"
          v-if="item.unlocked_status == 0"
        >
          <img :src="$utils.getPng('icon-short-byepNew')" class="noImg" />
          <span class="font5">{{ rebateText }}</span>
        </div>
        <div class="cBoxYes" v-else>
          <span class="font6">{{ item.jump_url }}</span>
          <svg-btn
            @click="copy(item.jump_url)"
            class="copyIcon"
            icon-class="icon-short-copy"
          />
        </div>
        <fm-button
          type="primary"
          round
          size="medium"
          class="Btn"
          :icon="
            item.unlocked_status == 0 ? 'icon-short-two' : 'icon-short-one'
          "
          @click="checkRebate($event, item)"
          >{{
            item.unlocked_status == 0 ? $t('model.Unlock') : $t('model.Open')
          }}</fm-button
        >
      </div>
    </template>
    <template v-if="detail.share_list.length > 1">
      <div class="boxFour">
        <div class="titleBox">
          <span class="title">目标网址</span>
          <span class="num">{{ detail.share_list.length }}</span>
        </div>
        <div
          class="arrBox"
          v-for="(item, index) in detail.share_list"
          :key="index"
        >
          <div class="topBox">
            <div class="imgBox">
              <img :src="item.icon" class="topImg" />
            </div>
            <span class="arrFont1">{{ item.url_title }}</span>
          </div>
          <div class="bottomBox">
            <div
              class="cBoxNo"
              @click="checkRebate($event, item)"
              v-if="item.unlocked_status == 0"
            >
              <img :src="$utils.getPng('icon-short-byepNew')" class="noImg" />
              <span class="font5">{{ rebateText }}</span>
            </div>
            <div class="cBoxYes" v-else>
              <span class="font6">{{ item.jump_url }}</span>
              <svg-btn
                @click="copy(item.jump_url)"
                class="copyIcon"
                icon-class="icon-short-copy"
              />
            </div>
            <fm-button
              type="primary"
              round
              size="medium"
              class="Btn"
              :icon="
                item.unlocked_status == 0 ? 'icon-short-two' : 'icon-short-one'
              "
              @click="checkRebate($event, item)"
              >{{
                item.unlocked_status == 0
                  ? $t('model.Unlock')
                  : $t('model.Open')
              }}</fm-button
            >
          </div>
        </div>
      </div>
    </template>
    <checkSocket
      :isShow="showWebsocket"
      :upWebsocket="upWebsocket"
      :type="socketType"
      :title="socketTitle"
      :videoQrdata="videoQrdata"
      @handleClose="showWebsocket = false"
      @refresh="openSocket(1)"
      @complete="complete"
    />
    <!-- 举报 -->
    <reportDialog
      ref="reportRef"
      type="pc"
      :isShow="showReport"
      :fshort="detail.fshort"
      @handleClose="showReport = false"
    ></reportDialog>
    <!-- 取消收藏提示框 -->
    <TitleDialog
      :is-show="collectShow"
      text="确定取消收藏该短链吗？"
      @handleClose="onCollectClose"
      @handleConfirm="onCollectConfirm"
    >
    </TitleDialog>
    <!-- 回到顶部按钮 -->
    <div v-show="isShowBackTop" @click="scrollToTop" class="backTop">
      <svg-btn icon-class="icon-short-backTop" class="img"></svg-btn>
    </div>
  </div>
</template>

<script>
import {
  getAdJumpQrcodeAPI,
  getJumpUrlAPI,
  checkUnlock,
  addShortColl,
  delShortColl,
} from '@/axios/home'
import TitleDialog from '@/components/Dialog/TitleDialog.vue'
import checkSocket from '@/components/checkSocket/index'
import reportDialog from '@/components/Dialog/reportDialog'
export default {
  components: {
    checkSocket,
    reportDialog,
    TitleDialog,
  },
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      upWebsocket: false,
      showWebsocket: false,
      videoQrdata: {},
      TimestampRandom: '',
      sc: '', //屏幕点击位置
      ms: '', //屏幕点击位置
      socketTitle: '',
      socketType: 1,
      showReport: false,
      isShowBackTop: false, // 控制按钮显示/隐藏
      scrollContainer: null, // 滚动容器DOM引用
      collectShow: false, //取消收藏弹窗是否显示
      zcFshort:'',//暂存fshort
    }
  },
  created() {
    this.generateTimestampRandom()
  },
  computed: {
    rebateText() {
      const { rebate_model } = this.detail
      const { isLogin } = this.$store.state
      const textMap = {
        2: isLogin ? this.$t('model.mtest21') : this.$t('model.mtest20'),
        3: isLogin ? this.$t('model.mtest17') : this.$t('model.mtest16'),
        4: isLogin ? this.$t('model.mtest19') : this.$t('model.mtest18'),
      }

      return textMap[rebate_model] || this.$t('model.mtest20')
    },
  },
  mounted() {
    this.scrollContainer = this.$refs.scrollContainer
    this.scrollContainer.addEventListener('scroll', this.handleScroll)
    // document.addEventListener('visibilitychange', this.handleVisiable)
  },
  destroyed() {
    if (this.scrollContainer) {
      this.scrollContainer.removeEventListener('scroll', this.handleScroll)
    }
    // document.removeEventListener('visibilitychange', this.handleVisiable)
  },
  methods: {
    checkCollect: _.debounce(
      async function () {
        let isLogin = localStorage.getItem('shortLogin')
        if (isLogin != 1) {
          this.toLogin()
          return
        } 
        if (this.detail.is_collect == 1) {
          this.collectShow = true
          return
        }
        addShortColl({
          short_url: this.detail.fshort,
        }).then(res => {
          if (res.status == 1) {
            this.detail.is_collect = 1
            this.$toast(res.msg, 1)
          } else {
            this.$toast(res.msg, 2)
          }
        })
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //确定取消收藏弹窗
    onCollectConfirm: _.debounce(
      async function () {
        delShortColl({
          short_url: this.detail.fshort,
        }).then(res => {
          if (res.status == 1) {
            this.onCollectClose()
            // this.$toast(res.msg, 1);
            this.detail.is_collect = 0
          } else {
            this.$toast(res.msg, 2)
          }
        })
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //关闭取消收藏弹窗
    onCollectClose() {
      this.collectShow = false
    },
    open(url) {
      window.open(url, '_href')
    },
    generateTimestampRandom() {
      // 获取当前时间戳（以秒为单位）
      const timestamp = Math.floor(Date.now() / 1000)
      // 生成一个随机数（例如范围在0到100之间）
      const randomNumber = Math.floor(Math.random() * 101)
      // 结合时间戳和随机数
      this.TimestampRandom = `${timestamp}_${randomNumber}`
    },
    // 小程序/app看视频完成后
    complete(obj) {
      this.updataAll()
    },
    copy(url) {
      this.$copyText(url).then(
        () => {
          this.$toast('复制链接成功', 1)
        },
        () => {
          this.$toast('复制链接失败', 2)
        }
      )
    },
    // 点击跳转链接
    checkRebate: _.debounce(
      async function (e, row) {
        // 1-免登录无条件跳转 2-登录后无条件跳转 3-去小程序看广告后跳转 4-去APP看广告后跳转
        try {
          //已经解锁了的就直接跳转
          if (row.unlocked_status == 1) {
            window.open(row.jump_url, '_href')
            return
          }
          e = e || window.event
          this.ms = e.clientX + '*' + e.clientY
          this.sc = window.screen.width + '*' + window.screen.height
          let data = {
            ms: this.ms,
            sc: this.sc,
            fshort: row.fshort,
          }
          let res = await getJumpUrlAPI(data)
          if (res.status == 1) {
            //这是为了解决多标签页下同一个短链状态不同步的处理方式
            let num = Number(res.data.rebate_model)
            if((num === 3 || num === 4) && Number(res.data.require_token) === 0){
              row.jump_url = res.data.jump_url
              row.unlocked_status = 1
              window.open(row.jump_url, '_href')
              return
            }
            switch (num) {
              case 1:
              case 2:
                //1-免登录无条件跳转 2-登录后无条件跳转(会先走到10020)
                // window.open(res.data.jump_url, '_href')
                row.jump_url = res.data.jump_url
                row.unlocked_status = 1
                break
              case 3:
              case 4:
                // 3-去小程序看广告后跳转 4-去APP看广告后跳转
                this.zcFshort = row.fshort
                this.socketType = num === 3 ? 2 : 1
                this.socketTitle =
                  num === 3
                    ? '微信扫码-看视频获取链接'
                    : 'APP扫码-看视频获取链接'
                this.upWebsocket = false
                this.openSocket()
                break
            }
            if (res.data.toast != '') {
              this.$toast(res.data.toast, 1)
            }
          } else if (res.status == 83001) {
            //短链的状态变更
            this.updataAll()
          } else if (res.status == 10020) {
            //请先登录
            this.toLogin()
            return
          }
        } catch (err) {
          // console.log('err', err)
        }
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    openSocket: _.debounce(
      async function (num = 0) {
        this.upWebsocket = false
        let data = {
          fshort: this.zcFshort,
          req_uuid: this.TimestampRandom,
        }
        getAdJumpQrcodeAPI(data)
          .then(res => {
            // console.log('getAdJumpQrcodeAPI', res)
            if (res.status == 1) {
              this.videoQrdata = res.data
              if (num == 1) {
                this.upWebsocket = true
              } else {
                this.showWebsocket = true
              }
            } else if (res.status == 10021) {
              this.$toast(res.msg, 4)
            }
          })
          .catch(err => {})
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    checkReport() {
      let isLogin = localStorage.getItem('shortLogin')
      if (isLogin && isLogin == 1) {
        this.showReport = true
      } else {
        this.toLogin()
      }
    },
    toLogin() {
      const lang = {
        en: '/en-US',
        hk: '/zh-HK',
        zh: '',
      }
      const from = 'short'
      const fromUrl = window.location.origin + this.$route.path
      const encodedFrom = encodeURIComponent(from)
      const encodedFromUrl = encodeURIComponent(fromUrl)
      let url = `${this.$glb.feemooUrl}${
        lang[this.$store.state.language]
      }/login?path=drive&from=${encodedFrom}&fromUrl=${encodedFromUrl}&is_recommend_expand=${
        this.detail.fshort
      }`
      this.$store.commit('setShowLoginShort', url)
      this.$store.commit('setShowLogin', true)
    },
    //重置状态
    updataAll() {
      this.zcFshort = ''
      this.showReport = false
      this.showWebsocket = false
      this.$store.commit('setShowLoginShort', '')
      this.$store.commit('setShowLogin', false)
      this.$store.commit('getShortDetail')
    },
    handleVisiable(e) {
      switch (e.target.visibilityState) {
        case 'visible':
          //满足条件，1 登录  2当前页面是未解锁状态 3后端告诉前端当前短链是否解锁
          let isLogin = localStorage.getItem('shortLogin')
          if (isLogin && isLogin == 1 && this.detail.unlocked_status == 0) {
            checkUnlock({
              fshort: this.detail.fshort,
            }).then(res => {
              if (res.status == 1) {
                if (res.data.unlockedStatus == 1) {
                  this.updataAll()
                }
              }
            })
          }
          break
      }
    },
    // 判断是否显示回到顶部按钮
    handleScroll() {
      const scrollTop = this.scrollContainer.scrollTop + 64
      const containerHeight = this.scrollContainer.clientHeight
      this.isShowBackTop = scrollTop > 72
    },

    // 回到顶部逻辑
    scrollToTop() {
      this.scrollContainer.scrollTo({
        top: 0,
        behavior: 'smooth', // 平滑滚动
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.BoxContent {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-height: calc(100vh - 64px);
  .boxOne {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    border-radius: 32px;
    // margin-top: 32px;
    width: 576px;
    // height: 124px;
    min-height: 124px;
    // max-height: 124px;
    margin-bottom: 20px;
    padding: 40px 36px;
    .leftLogo {
      width: 44px;
      height: 44px;
      object-fit: cover;
      border-radius: 50%;
    }
    .rightBox {
      display: flex;
      flex-direction: column;
      margin-left: 12px;
      flex: 1;
      .topBox {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .leftU {
          .font1 {
            font-weight: 500;
            font-size: 16px;
            color: #2c2c2c;
            line-height: 22px;
            margin-bottom: 2px;
            @include multiline(1);
          }
          .font2 {
            font-weight: 400;
            font-size: 12px;
            color: #8a8b92;
            line-height: 20px;
            flex: 1;
            // max-width: 404px;
            // @include multiline(2);
            // @include multiline(1);
          }
          .font3 {
            font-weight: 400;
            font-size: 12px;
            color: #f67942;
            line-height: 20px;
            margin-left: 8px;
            cursor: pointer;
          }
        }
        .collect {
          margin-left: 12px;
          width: 24px;
          height: 24px;
          cursor: pointer;
          color: #bdbdbe;
        }
        .collect:hover {
          color: #f67942;
        }
      }
    }
  }
  .boxTwo {
    width: 576px;
    height: 324px;
    min-height: 324px;
    max-height: 324px;
    background: #ffffff;
    border-radius: 32px;
    ::v-deep .el-carousel {
      height: 100%;
      border-radius: 32px;
      .el-carousel__container {
        height: 100% !important;
      }
      .el-carousel__indicator {
        padding: 0;
        margin-right: 4px;
        margin-bottom: 24px;
      }
      .is-active {
        .el-carousel__button {
          width: 20px !important;
          opacity: 1 !important;
        }
      }
      .el-carousel__button {
        width: 8px;
        height: 8px;
        background: #ffffff;
        border-radius: 5px;
        opacity: 0.6;
      }
    }
    .img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 32px;
    }
  }
  .boxThree {
    width: 576px;
    height: 276px;
    min-height: 276px;
    max-height: 276px;
    background: #ffffff;
    border-radius: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 40px 36px;
    .topBox {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      margin-bottom: 32px;
      .imgBox {
        width: 44px;
        height: 44px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 0.5px solid #e5e5e5;
        .topImg {
          width: 24px;
          height: 24px;
          object-fit: cover;
          border-radius: 6px;
        }
      }
      .font4 {
        font-weight: 500;
        font-size: 16px;
        color: #2c2c2c;
        line-height: 22px;
        margin-left: 12px;
        max-width: 448px;
        flex: 1;
        @include multiline(2);
      }
    }
    .cBoxNo {
      position: relative;
      width: 100%;
      height: 44px;
      margin-bottom: 28px;
      cursor: pointer;
      .noImg {
        width: 100%;
        height: 100%;
      }
      .font5 {
        font-weight: 400;
        font-size: 14px;
        color: #2c2c2c;
        line-height: 22px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        max-width: 100%;
        width: 100%;
        text-align: center;
        padding: 0 12px;
        @include multiline(1);
      }
    }
    .cBoxYes {
      width: 100%;
      margin-bottom: 28px;
      background: #f6f6f6;
      border-radius: 8px;
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      padding: 0 48px;
      // padding-right: 20px;
      .font6 {
        font-weight: 400;
        font-size: 14px;
        color: #2c2c2c;
        line-height: 22px;
        max-width: 100%;
        text-align: center;
        -webkit-user-select: text;
        -moz-user-select: text;
        -ms-user-select: text;
        user-select: text;
        cursor: auto;
        @include multiline(1);
      }
      .copyIcon {
        width: 16px;
        height: 16px;
        cursor: pointer;
        position: absolute;
        right: 20px;
      }
    }
    ::v-deep .Btn {
      padding: 0 40px;
      height: 48px;
      border-radius: 26px;
      .svg-icon {
        width: 20px;
        height: 20px;
      }
      span {
        font-weight: 500;
        font-size: 16px;
        color: #ffffff;
        line-height: 24px;
        margin-right: 0;
        margin-left: 8px;
      }
    }
  }
  .boxFour {
    width: 576px;
    background: #ffffff;
    border-radius: 32px;
    padding: 36px;
    .titleBox {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      .title {
        font-weight: 500;
        font-size: 16px;
        color: #2c2c2c;
        line-height: 24px;
        margin-right: 12px;
        flex-shrink: 0;
      }
      .num {
        font-weight: 500;
        font-size: 16px;
        color: #8a8b92;
        line-height: 24px;
        @include multiline(1);
      }
    }
    .arrBox {
      margin-bottom: 24px;
      padding-bottom: 24px;
      box-shadow: inset 0px -0.5px 0px 0px #e5e5e5;
      &:last-child {
        box-shadow: none !important;
        margin-bottom: 0 !important;
        padding-bottom: 0 !important;
      }
      .topBox {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        margin-bottom: 24px;
        .imgBox {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 0.5px solid #e5e5e5;
          .topImg {
            width: 24px;
            height: 24px;
            object-fit: cover;
            border-radius: 6px;
          }
        }
        .arrFont1 {
          font-weight: 500;
          font-size: 16px;
          color: #2c2c2c;
          line-height: 22px;
          margin-left: 12px;
          max-width: 448px;
          flex: 1;
          @include multiline(2);
        }
      }
      .bottomBox {
        display: flex;
        align-items: center;
        .cBoxNo {
          position: relative;
          width: 100%;
          height: 44px;
          cursor: pointer;
          .noImg {
            width: 100%;
            height: 100%;
          }
          .font5 {
            font-weight: 400;
            font-size: 14px;
            color: #2c2c2c;
            line-height: 22px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            max-width: 100%;
            width: 100%;
            text-align: center;
            padding: 0 12px;
            @include multiline(1);
          }
        }
        .cBoxYes {
          width: 100%;
          background: #f6f6f6;
          border-radius: 8px;
          height: 44px;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          padding: 0 48px;
          // padding-right: 20px;
          .font6 {
            font-weight: 400;
            font-size: 14px;
            color: #2c2c2c;
            line-height: 22px;
            max-width: 100%;
            text-align: center;
            -webkit-user-select: text;
            -moz-user-select: text;
            -ms-user-select: text;
            user-select: text;
            cursor: auto;
            @include multiline(1);
          }
          .copyIcon {
            width: 16px;
            height: 16px;
            cursor: pointer;
            position: absolute;
            right: 20px;
          }
        }
        ::v-deep .Btn {
          padding: 0 27px 0 25px;
          height: 44px;
          border-radius: 26px;
          margin-left: 16px;
          .svg-icon {
            width: 20px;
            height: 20px;
          }
          span {
            font-weight: 500;
            font-size: 16px;
            color: #ffffff;
            line-height: 24px;
            margin-right: 0;
            margin-left: 4px;
          }
        }
      }
    }
  }
}
.BoxMore {
  overflow: auto;
  justify-content: flex-start !important;
  padding: 72px 0;
  height: calc(100vh - 64px);
  overflow-y: auto;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
}
.BoxMore::-webkit-scrollbar {
  display: block;
  width: 7px;
  height: 1px;
}
.BoxMore::-webkit-scrollbar-track {
  border-radius: 10px;
  background: transparent;
}
.BoxMore::-webkit-scrollbar-thumb {
  background: rgba(217, 217, 217, 0.92);
  -webkit-box-shadow: none;
  border-radius: 4px;
}
.backTop {
  position: fixed;
  bottom: 24px;
  right: 32px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  cursor: pointer;
  background: #ffffff;
  box-shadow: 0px 0px 18px 0px rgba(0, 0, 0, 0.08);
  border: 1px solid #e3e5e8;
  display: flex;
  justify-content: center;
  align-items: center;
  .img {
    width: 24px;
    height: 24px;
  }
}
</style>
